module.exports = __webpack_public_path__ + "img/tunuve_invertido.38a6734b.png";